/* VialArt - Upload Your Own Label : client-side artwork validation + cart-add.
   Validation is UX only; Label Farm re-audits server-side and holds every
   upload for manual operator approval before printing. */
(function () {
  'use strict';

  function init() {
    var cfg = {};
    try { cfg = JSON.parse(document.getElementById('va-upl-cfg').textContent); } catch (e) { cfg = {}; }
    var PRINT_W = +cfg.printW || 1.77, PRINT_H = +cfg.printH || 0.75;
    var DPI_PASS = +cfg.dpiPass || 300, DPI_MIN = +cfg.dpiMin || 200;
    var MAX_MB = +cfg.maxMb || 20, MAX_BYTES = MAX_MB * 1024 * 1024;
    var PACKS = cfg.packs || [];
    var MATERIALS = cfg.materials || [];
    var VARIANTS = window.VIALART_UPLOAD_VARIANTS || {};
    var LONG = Math.max(PRINT_W, PRINT_H), SHORT = Math.min(PRINT_W, PRINT_H);

    var el = function (id) { return document.getElementById(id); };
    var fileInput = el('va-upl-file');
    var drop = el('va-drop'), choose = el('va-choose');
    var prow = el('va-preview-row'), thumb = el('va-thumb'), finfo = el('va-finfo');
    var vbox = el('va-valid'), abox = el('va-acks');
    var matsBox = el('va-mats'), packsBox = el('va-packs'), priceBox = el('va-price');
    var btn = el('va-addcart'), form = el('va-upl-form');
    if (!fileInput || !drop || !btn) { return; }

    var st = { file: null, vres: null, material: (MATERIALS[0] || {}).name || 'Aurora', qty: 100, acks: {}, stock: {}, objUrl: null, art: { mode: 'cover', scale: 1, x: 0, y: 0, dpi: null }, fitActive: false };
    MATERIALS.forEach(function (m) { st.stock[m.name] = true; });

    /* ---------- helpers ---------- */
    function packName(q) { if (q >= 1000) return 'Bulk Production Pack'; if (q >= 250) return 'Commercial Pack'; if (q >= 50) return 'Brand Pack'; return 'Starter Pack'; }
    function snapPack(q) { var best = PACKS.length ? PACKS[0].q : 100, bd = Infinity; PACKS.forEach(function (p) { var d = Math.abs(p.q - q); if (d < bd) { bd = d; best = p.q; } }); return best; }
    function matFactor() { return 1.0; /* all films same price */ } function priceFor(q) { for (var i = 0; i < PACKS.length; i++) { if (PACKS[i].q === q) return Math.round(PACKS[i].price * matFactor() * 100) / 100; } return 0; }
    function fmtMB(b) { var v = b / 1048576; return v < 10 ? v.toFixed(1) : Math.round(v); }
    function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

    /* holo print simulation: previews composite the art (multiply) over the
       selected film texture so white/transparent areas shimmer like the real
       print. Display-only — the uploaded file itself is never modified. */
    function filmClass() { return String(st.material || '').toLowerCase().indexOf('prism') > -1 ? 'va-film-prism' : 'va-film-aurora'; }
    function filmSync() {
      var f = el('va-fit-film'); if (f) f.className = 'va-fit-film ' + filmClass();
      var tb = document.querySelector('#va-truesize .va-ts-box'); if (tb) tb.className = 'va-ts-box ' + filmClass();
    }

    function sniff(buf) {
      var u = new Uint8Array(buf);
      if (u[0] === 0x89 && u[1] === 0x50 && u[2] === 0x4E && u[3] === 0x47) return 'png';
      if (u[0] === 0xFF && u[1] === 0xD8 && u[2] === 0xFF) return 'jpg';
      if (u[0] === 0x25 && u[1] === 0x50 && u[2] === 0x44 && u[3] === 0x46) return 'pdf';
      if (u[0] === 0x47 && u[1] === 0x49 && u[2] === 0x46) return 'gif';
      if (u[0] === 0x52 && u[1] === 0x49 && u[2] === 0x46 && u[3] === 0x46 && u[8] === 0x57 && u[9] === 0x45 && u[10] === 0x42 && u[11] === 0x50) return 'webp';
      var head = ''; for (var i = 0; i < Math.min(u.length, 200); i++) head += String.fromCharCode(u[i]);
      head = head.toLowerCase();
      if (head.indexOf('<svg') >= 0 || (head.indexOf('<?xml') >= 0 && head.indexOf('svg') >= 0)) return 'svg';
      return 'other';
    }

    function decodeDims(file) {
      return new Promise(function (resolve, reject) {
        if (window.createImageBitmap) {
          createImageBitmap(file).then(function (bm) { var d = { w: bm.width, h: bm.height }; if (bm.close) bm.close(); resolve(d); })
            .catch(function () { fallback(); });
        } else { fallback(); }
        function fallback() {
          var url = URL.createObjectURL(file), im = new Image();
          im.onload = function () { var d = { w: im.naturalWidth, h: im.naturalHeight }; URL.revokeObjectURL(url); resolve(d); };
          im.onerror = function () { URL.revokeObjectURL(url); reject(new Error('decode')); };
          im.src = url;
        }
      });
    }

    function blankScan(file) {
      return new Promise(function (resolve) {
        if (!window.createImageBitmap) { resolve(null); return; }
        createImageBitmap(file).then(function (bm) {
          try {
            var c = document.createElement('canvas'); c.width = 64; c.height = 64;
            var ctx = c.getContext('2d'); ctx.drawImage(bm, 0, 0, 64, 64); if (bm.close) bm.close();
            var d = ctx.getImageData(0, 0, 64, 64).data, n = 64 * 64;
            var allAlpha0 = true, anyAlphaLt = false, sum = 0, vals = [];
            for (var i = 0; i < d.length; i += 4) { var a = d[i + 3]; if (a !== 0) allAlpha0 = false; if (a < 255) anyAlphaLt = true; var lum = (d[i] + d[i + 1] + d[i + 2]) / 3; sum += lum; vals.push(lum); }
            var mean = sum / n, vc = 0; for (var j = 0; j < vals.length; j++) { var dv = vals[j] - mean; vc += dv * dv; }
            resolve({ allAlpha0: allAlpha0, anyAlphaLt: anyAlphaLt, std: Math.sqrt(vc / n) });
          } catch (e) { resolve(null); }
        }).catch(function () { resolve(null); });
      });
    }

    function isAnimatedPng(file) {
      return file.slice(0, 131072).arrayBuffer().then(function (buf) {
        var u = new Uint8Array(buf), s = ''; for (var i = 0; i < u.length; i++) s += String.fromCharCode(u[i]);
        var actl = s.indexOf('acTL'), idat = s.indexOf('IDAT');
        return actl >= 0 && (idat < 0 || actl < idat);
      }).catch(function () { return false; });
    }

    // Print-legibility (shrink) gate: render the art at its TRUE printed size
    // (placedMm wide @ 203-DPI thermal) and measure the fraction of foreground ink
    // in <=1px (~0.13mm) strokes - thin lines/small text that mush at label size.
    // Mirrors the calibrated Python metric; a full label blocks at >=0.75 (good
    // labels with normal lot/exp text score <=0.60).
    function detailScan(file, placedMm) {
      return new Promise(function (resolve) {
        function calc(src, w, h) {
          try {
            var pw = Math.max(8, Math.round(placedMm / 25.4 * 203)), ph = Math.max(4, Math.round(h * pw / w));
            var c = document.createElement('canvas'); c.width = pw; c.height = ph;
            var cx = c.getContext('2d', { willReadFrequently: true });
            cx.imageSmoothingEnabled = true; cx.imageSmoothingQuality = 'high';
            cx.drawImage(src, 0, 0, pw, ph);
            var d = cx.getImageData(0, 0, pw, ph).data, n = pw * ph, i;
            var gray = new Uint8Array(n), hist = new Uint32Array(256);
            for (i = 0; i < n; i++) { var g = (0.2126 * d[i * 4] + 0.7152 * d[i * 4 + 1] + 0.0722 * d[i * 4 + 2]) | 0; gray[i] = g; hist[g]++; }
            var bg = 0, bc = 0; for (i = 0; i < 256; i++) if (hist[i] > bc) { bc = hist[i]; bg = i; }
            var fg = new Uint8Array(n), fgc = 0;
            for (i = 0; i < n; i++) if (Math.abs(gray[i] - bg) > 40) { fg[i] = 1; fgc++; }
            if (fgc < 8) { resolve(0); return; }
            var er = 0, x, y, dx, dy, keep;
            for (y = 0; y < ph; y++) for (x = 0; x < pw; x++) {
              if (!fg[y * pw + x]) continue; keep = 1;
              for (dy = -1; dy <= 1 && keep; dy++) for (dx = -1; dx <= 1; dx++) {
                var ny = y + dy, nx = x + dx;
                if (ny < 0 || nx < 0 || ny >= ph || nx >= pw || !fg[ny * pw + nx]) { keep = 0; break; }
              }
              if (keep) er++;
            }
            resolve(1 - er / fgc);
          } catch (e) { resolve(0); }
        }
        if (window.createImageBitmap) {
          createImageBitmap(file).then(function (bm) { var w = bm.width, h = bm.height; calc(bm, w, h); if (bm.close) bm.close(); }).catch(function () { resolve(0); });
        } else {
          var url = URL.createObjectURL(file), im = new Image();
          im.onload = function () { URL.revokeObjectURL(url); calc(im, im.naturalWidth, im.naturalHeight); };
          im.onerror = function () { URL.revokeObjectURL(url); resolve(0); };
          im.src = url;
        }
      });
    }

    /* ---------- validation ---------- */
    function validate(file) {
      var msgs = [], acks = [], tier = 'pass', dpi = null;
      function bump(t) { if (t === 'error') tier = 'error'; else if (t === 'warning' && tier !== 'error') tier = 'warning'; }
      function done() {
        var head = tier === 'error' ? 'This needs a quick fix before it can print:'
                 : tier === 'warning' ? ('Almost ready - just confirm the note' + (acks.length === 1 ? '' : 's') + ' below, then add to cart.')
                 : 'Looks great - your artwork is ready to print.';
        msgs.unshift({ tier: tier, text: head });
        return { tier: tier, dpi: dpi, messages: msgs, acks: acks };
      }

      return file.slice(0, 200).arrayBuffer().then(function (head) {
        var ty = sniff(head);
        if (ty === 'gif') return { tier: 'error', dpi: null, messages: [{ tier: 'error', text: "GIFs aren't supported (they're usually animated and low-res). Please upload a PNG, JPG, PDF, or SVG." }], acks: [] };
        if (ty === 'other') return { tier: 'error', dpi: null, messages: [{ tier: 'error', text: "We can't use that file type. Please upload a PNG, JPG, WEBP, PDF, or SVG." }], acks: [] };
        if (file.size > MAX_BYTES) return { tier: 'error', dpi: null, messages: [{ tier: 'error', text: 'This file is too large (' + fmtMB(file.size) + ' MB). Please keep it under ' + MAX_MB + ' MB.' }], acks: [] };
        if ((ty === 'png' || ty === 'jpg' || ty === 'webp') && file.size < 10 * 1024) return { tier: 'error', dpi: null, messages: [{ tier: 'error', text: 'This file is very small (' + (file.size / 1024).toFixed(1) + ' KB) and is likely too low-detail to print. Please upload a higher-quality file.' }], acks: [] };
        if (file.size > 15 * 1024 * 1024) { msgs.push({ tier: 'warning', text: 'Large file (' + fmtMB(file.size) + ' MB) - the upload may take a moment.' }); bump('warning'); acks.push({ id: 'bigfile', label: 'I understand the upload may take a moment.' }); }

        if (ty === 'svg') { msgs.unshift({ tier: 'pass', text: 'Vector SVG accepted - it scales cleanly to any size.' }); return done(); }
        if (ty === 'pdf') { msgs.unshift({ tier: 'pass', text: 'PDF accepted. If it contains a low-resolution photo it may still print soft - our team reviews every upload before printing.' }); return done(); }

        // raster (png/jpg)
        var animChk = ty === 'png' ? isAnimatedPng(file) : Promise.resolve(false);
        return animChk.then(function (anim) {
          if (anim) return { tier: 'error', dpi: null, messages: [{ tier: 'error', text: "Animated images aren't supported. Please upload a single still frame." }], acks: [] };
          return decodeDims(file).then(function (dim) {
            var w = dim.w, h = dim.h, mp = (w * h) / 1e6;
            if (mp > 100) return { tier: 'error', dpi: null, messages: [{ tier: 'error', text: 'This image is enormous (' + mp.toFixed(0) + ' megapixels). Please resize it under 100 MP.' }], acks: [] };
            if (mp > 40) { msgs.push({ tier: 'warning', text: 'Very large image (' + mp.toFixed(0) + ' MP) - it will work but may be slow to process.' }); bump('warning'); acks.push({ id: 'bigmp', label: 'I understand a very large image may be slow to process.' }); }

            var longPx = Math.max(w, h), shortPx = Math.min(w, h);
            dpi = Math.floor(Math.min(longPx / LONG, shortPx / SHORT));
            var need = Math.ceil(LONG * DPI_PASS) + 'x' + Math.ceil(SHORT * DPI_PASS);
            if (dpi >= DPI_PASS) { msgs.push({ tier: 'pass', text: 'Sharp resolution - ' + dpi + ' DPI at this label size.' }); }
            else if (dpi >= DPI_MIN) { msgs.push({ tier: 'warning', text: 'A little low-res (' + dpi + ' DPI). It will print but may look slightly soft - ' + DPI_PASS + ' DPI or higher is best (about ' + need + ' px).' }); bump('warning'); acks.push({ id: 'lowdpi', label: 'I understand my artwork is ' + dpi + ' DPI and may print slightly soft.' }); }
            else { msgs.push({ tier: 'error', text: 'Too low-res to print clearly - only ' + dpi + ' DPI (we need at least ' + DPI_MIN + '). Please upload a larger or higher-quality file - about ' + need + ' px or bigger prints crisp.' }); bump('error'); }

            var arImg = longPx / shortPx, arLabel = LONG / SHORT, ad = Math.abs(arImg - arLabel) / arLabel;
            /* aspect is now handled interactively by the fit tool (customer frames the art) */

            return blankScan(file).then(function (bs) {
              if (bs) {
                if (bs.allAlpha0) return { tier: 'error', dpi: dpi, messages: [{ tier: 'error', text: 'This image appears to be completely empty / transparent.' }], acks: [] };
                if (bs.std < 2) { msgs.push({ tier: 'warning', text: 'This image looks blank or a single solid color. Double-check you uploaded the right file.' }); bump('warning'); acks.push({ id: 'blank', label: 'I confirm this is the artwork I want printed.' }); }
                if (bs.anyAlphaLt) { msgs.push({ tier: 'warning', text: 'Your artwork has transparent areas - these print as the material color, not white.' }); bump('warning'); acks.push({ id: 'transp', label: 'I understand transparent areas print as the material color.' }); }
              }
              return detailScan(file, LONG * 25.4).then(function (loss) {
                if (loss >= 0.75) {
                  msgs.push({ tier: 'error', text: 'This artwork has very fine lines or small text that would blur or disappear when printed at label size (about 45\u00d719mm). Please redesign it bolder and simpler, or let our AI Label Studio create a print-ready label for you: vialart.com/pages/ai-label-studio' });
                  bump('error');
                }
                return done();
              });
            });
          }).catch(function () { return { tier: 'error', dpi: null, messages: [{ tier: 'error', text: "We couldn't read that image. Please re-export it as a PNG or JPG and try again." }], acks: [] }; });
        });
      });
    }

    /* ---------- rendering ---------- */
    function vaTrueSize(ty) {
      var ex = document.getElementById('va-truesize');
      if (ty === 'pdf' || !st.objUrl) { if (ex) ex.remove(); return; }
      if (!document.getElementById('va-ts-css')) {
        var stl = document.createElement('style'); stl.id = 'va-ts-css';
        stl.textContent = '.va-ts{margin:14px 0;padding:14px;background:#14112a;border:1px solid #2b2748;border-radius:12px;}'
          + '.va-ts h4{margin:0 0 4px;font-size:13.5px;color:#fff;font-weight:800;}'
          + '.va-ts p{margin:0 0 12px;font-size:12px;color:#a7adc6;line-height:1.45;}'
          + '.va-ts p b{color:#ffce55;}'
          + '.va-ts-box{width:' + PRINT_W + 'mm;height:' + PRINT_H + 'mm;max-width:100%;border-radius:1mm;overflow:hidden;background:#fff;box-shadow:0 2px 12px rgba(0,0,0,.4);}'
          + '.va-ts-box img{width:100%;height:100%;object-fit:cover;display:block;}'
          + '.va-ts-cap{font-size:10.5px;color:#8d82b5;margin-top:5px;}'
          + '.va-ts-guide{margin-top:12px;font-size:11.5px;color:#a7adc6;line-height:1.5;}'
          + '.va-ts-guide b{color:#fff;}'
          + '.va-ts-guide table{width:100%;border-collapse:collapse;margin:7px 0;}'
          + '.va-ts-guide td{padding:4px 6px;border-top:1px solid #241f3f;font-size:11.5px;}'
          + '.va-ts-guide td:nth-child(2){color:#c9b3ff;white-space:nowrap;}'
          + '.va-ts-guide td:nth-child(3){color:#7ee0a8;font-weight:700;white-space:nowrap;text-align:right;}';
        document.head.appendChild(stl);
      }
      if (!ex) {
        ex = document.createElement('div'); ex.id = 'va-truesize'; ex.className = 'va-ts';
        abox.parentNode.insertBefore(ex, abox);
      }
      var _guide = '';
      if (st.dims && st.dims.w && st.dims.h) {
        var _mmpp = Math.max(PRINT_W / st.dims.w, PRINT_H / st.dims.h);   // mm per px at print
        var _px = function (mm) { return Math.ceil(mm / _mmpp); };
        _guide = '<div class="va-ts-guide"><b>Text size guide</b> &mdash; sizes our own designs use, converted to pixels for your ' + st.dims.w + '&times;' + st.dims.h + 'px file:'
          + '<table>'
          + '<tr><td>Main title / compound</td><td>3.5&ndash;4.5 mm</td><td>&#8805; ' + _px(3.5) + ' px tall</td></tr>'
          + '<tr><td>Dose / secondary line</td><td>&#8805; 2 mm</td><td>&#8805; ' + _px(2) + ' px</td></tr>'
          + '<tr><td>Fine print (lot, dates, notes)</td><td>&#8805; 1.2 mm</td><td>&#8805; ' + _px(1.2) + ' px</td></tr>'
          + '</table>Anything under ' + _px(1.2) + ' px tall in your file will be unreadable when printed. Zooming in with the crop tool makes text print larger.'
          + '<br><br><b>Designing in Canva?</b> Easiest: set your canvas to exactly <b>45 &times; 19 mm</b> (Create a design &rarr; Custom size &rarr; mm) and use font sizes: <b>title 11&ndash;13</b>, <b>secondary 6&ndash;7</b>, <b>fine print 4 minimum</b>. On this pixel canvas, your Canva font size should be about &frac34; of the pixel values above (&#8805; ' + Math.ceil(_px(1.2) * 0.75) + ' for fine print, &#8805; ' + Math.ceil(_px(3.5) * 0.75) + ' for the title).</div>';
      }
      ex.innerHTML = '<h4>&#128207; Actual print size check</h4>'
        + '<p>This is approximately how big your label prints, shown on your chosen holographic film &mdash; <b>white and transparent areas aren&rsquo;t printed, the film shimmers through them</b>. <b>If you can&rsquo;t read your text here, it won&rsquo;t be readable on the vial</b> &mdash; make the text bigger or simpler in your artwork before ordering.</p>'
        + '<div class="va-ts-box ' + filmClass() + '"><img src="' + st.objUrl + '" alt="Your artwork at actual print size"></div>'
        + '<div class="va-ts-cap">' + PRINT_W + ' &times; ' + PRINT_H + ' mm (1.77 &times; 0.75 in) &mdash; real-world size, approximate on some screens</div>'
        + _guide;
    }

    function showPreview(file, ty) {
      if (st.objUrl) { URL.revokeObjectURL(st.objUrl); st.objUrl = null; }
      prow.classList.add('on');
      if (ty === 'pdf') { thumb.innerHTML = '<span class="va-pdf">PDF</span>'; }
      else { st.objUrl = URL.createObjectURL(file); thumb.innerHTML = '<img alt="preview" src="' + st.objUrl + '">'; }
      var kb = file.size / 1024, sz = kb < 1024 ? kb.toFixed(0) + ' KB' : (kb / 1024).toFixed(1) + ' MB';
      finfo.innerHTML = '<span class="va-fn">' + esc(file.name) + '</span><br>' + (st.dims ? (st.dims.w + ' x ' + st.dims.h + ' px - ') : '') + sz;
      vaTrueSize(ty);
    }

    function renderValidation() {
      var v = st.vres;
      if (v && v.tier !== 'error' && st.objUrl) {
        v.acks = v.acks || [];
        if (!v.acks.some(function (a) { return a.id === 'sizecheck'; }))
          v.acks.push({ id: 'sizecheck', label: 'I viewed my artwork at actual print size above — my text is readable this small.' });
      }
      if (!v) { vbox.className = 'va-valid'; abox.className = 'va-acks'; abox.innerHTML = ''; return; }
      vbox.className = 'va-valid on ' + v.tier;
      vbox.innerHTML = v.messages.map(function (m) { return '<div class="va-vmsg">' + esc(m.text) + '</div>'; }).join('');
      st.acks = {};
      if (v.acks && v.acks.length) {
        abox.className = 'va-acks on';
        abox.innerHTML = v.acks.map(function (a) { return '<label class="va-ack"><input type="checkbox" data-ack="' + esc(a.id) + '"><span>' + esc(a.label) + '</span></label>'; }).join('');
        [].slice.call(abox.querySelectorAll('input[data-ack]')).forEach(function (cb) {
          cb.addEventListener('change', function () { st.acks[cb.getAttribute('data-ack')] = cb.checked; updateButton(); });
        });
      } else { abox.className = 'va-acks'; abox.innerHTML = ''; }
    }

    function renderMaterials() {
      matsBox.innerHTML = MATERIALS.map(function (m) {
        var oos = st.stock[m.name] === false;
        var sel = m.name === st.material && !oos;
        return '<div class="va-mat' + (sel ? ' sel' : '') + (oos ? ' oos' : '') + '" role="button" tabindex="' + (oos ? '-1' : '0') + '" aria-pressed="' + (sel ? 'true' : 'false') + '"' + (oos ? ' aria-disabled="true"' : '') + ' data-mat="' + esc(m.name) + '">' +
          '<div class="va-sw ' + esc(m.sw || '') + '"></div>' +
          '<div class="va-mn">' + esc(m.name) + '</div><div class="va-md">' + esc(m.desc || '') + '</div>' +
          '<div class="va-oostag">Out of stock</div></div>';
      }).join('');
      [].slice.call(matsBox.querySelectorAll('.va-mat')).forEach(function (t) {
        t.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); t.click(); } });
        t.addEventListener('click', function () {
          var name = t.getAttribute('data-mat');
          if (st.stock[name] === false) return;
          st.material = name; renderMaterials(); renderPacks(); filmSync(); updateButton();
        });
      });
    }

    function renderPacks() {
      packsBox.innerHTML = PACKS.map(function (p) {
        return '<div class="va-pack' + (p.q === st.qty ? ' sel' : '') + '" data-q="' + p.q + '">' +
          '<div class="va-pq">' + p.q + '</div><div class="va-pp">$' + (Math.round(p.price * matFactor() * 100) / 100).toFixed(2) + '</div><div class="va-ppe">$' + ((Math.round(p.price * matFactor() * 100) / 100) / p.q).toFixed(2) + '/label</div></div>';
      }).join('');
      [].slice.call(packsBox.querySelectorAll('.va-pack')).forEach(function (t) {
        t.addEventListener('click', function () { st.qty = +t.getAttribute('data-q'); renderPacks(); updatePrice(); updateButton(); });
      });
      updatePrice();
    }

    function updatePrice() {
      priceBox.innerHTML = '<span class="va-pname">' + esc(packName(st.qty)) + '</span><br>' + st.qty + ' labels &middot; <b>$' + priceFor(st.qty).toFixed(2) + '</b>';
    }

    function updateButton() {
      var label, ok = false;
      if (!st.file) { label = 'Upload artwork to start'; }
      else if (!st.vres) { label = 'Checking artwork...'; }
      else if (st.vres.tier === 'error') { label = 'Fix the artwork to continue'; }
      else if (st.stock[st.material] === false) { label = 'Selected paper is out of stock'; }
      else {
        var allAck = (st.vres.acks || []).every(function (a) { return st.acks[a.id]; });
        if (!allAck) { label = 'Check the boxes above to continue'; }
        else { ok = true; label = 'Add to cart - $' + priceFor(st.qty).toFixed(2); }
      }
      if (ok && st.fitActive && st.art && st.art.dpi != null && st.art.dpi < DPI_MIN) { ok = false; label = 'Zoom out a little \u2014 too low-res at this size'; }
      btn.disabled = !ok; btn.textContent = label;
    }

    /* ---------- file handling ---------- */
    function handleFile(file) {
      if (!file) return;
      st.file = file; st.vres = null; st.dims = null; st.art = { mode: 'cover', scale: 1, x: 0, y: 0, dpi: null }; st.fitActive = false;
      file.slice(0, 200).arrayBuffer().then(function (h) {
        var ty = sniff(h);
        showPreview(file, ty);
      });
      updateButton();
      validate(file).then(function (res) {
        if (st.file !== file) return;
        st.vres = res;
        // refresh dims line if we have them
        decodeDims(file).then(function (d) { st.dims = d; if (st.file === file) { file.slice(0, 200).arrayBuffer().then(function (h) { var _ty = sniff(h); showPreview(file, _ty); fitSetup(file, _ty); }); } }).catch(function () {});
        renderValidation(); updateButton();
      }).catch(function () {
        if (st.file !== file) return;
        st.vres = { tier: 'error', dpi: null, messages: [{ tier: 'error', text: "We couldn't read that file - please re-select it or try a different copy." }], acks: [] };
        renderValidation(); updateButton();
      });
    }

    function setInputFile(file) {
      try { var dt = new DataTransfer(); dt.items.add(file); fileInput.files = dt.files; } catch (e) {}
    }
    // AI Label Studio feeds its generated design into the SAME validate/fit/cart
    // pipeline as a hand-picked file (setInputFile so the multipart cart form
    // carries it too).
    window.vaHandleFile = function (file) { setInputFile(file); handleFile(file); };

    /* ---------- artwork fit tool: customer frames the art to the label ---------- */
    var LBL_W_MM = LONG * 25.4;
    function fitInit() {
      var host = el('va-fit'); if (!host) return;
      host.innerHTML =
        '<div class="va-fit-lbl">Your label preview &mdash; frame your artwork</div>'
      + '<div class="va-fit-msg" id="va-fit-msg"></div>'
      + '<div class="va-fit-stage" id="va-fit-stage"><div class="va-fit-film" id="va-fit-film"></div><div class="va-fit-art" id="va-fit-art"></div><div class="va-fit-frame"></div></div>'
      + '<div class="va-fit-ctrls">'
      +   '<div class="va-fit-modes"><button type="button" class="va-fit-mode on" data-mode="cover">Fill label</button><button type="button" class="va-fit-mode" data-mode="contain">Fit whole</button></div>'
      +   '<label class="va-fit-zoom">Zoom<input type="range" id="va-fit-zoom" min="50" max="300" value="100"></label>'
      +   '<button type="button" class="va-fit-reset" id="va-fit-reset">Reset</button>'
      +   '<span class="va-fit-dpi" id="va-fit-dpi"></span>'
      + '</div>'
      + '<div class="va-fit-hint"><b>Pinch</b> (or scroll / use the slider) to zoom · <b>drag</b> to reposition · white &amp; transparent areas aren’t printed — the holographic film shows through (previewed here).</div>';
      [].slice.call(host.querySelectorAll('.va-fit-mode')).forEach(function (b) {
        b.addEventListener('click', function () {
          st.art.mode = b.getAttribute('data-mode'); st.art.x = 0; st.art.y = 0; st.art.scale = 1;
          host.querySelectorAll('.va-fit-mode').forEach(function (x) { x.classList.toggle('on', x === b); });
          var z = el('va-fit-zoom'); if (z) z.value = 100; fitRender();
        });
      });
      var zoom = el('va-fit-zoom'); if (zoom) zoom.addEventListener('input', function () { st.art.scale = (+zoom.value) / 100; fitRender(); });
      var rs = el('va-fit-reset'); if (rs) rs.addEventListener('click', function () {
        st.art.mode = 'cover'; st.art.scale = 1; st.art.x = 0; st.art.y = 0;
        var z = el('va-fit-zoom'); if (z) z.value = 100;
        host.querySelectorAll('.va-fit-mode').forEach(function (x) { x.classList.toggle('on', x.getAttribute('data-mode') === 'cover'); });
        fitRender();
      });
      var stage = el('va-fit-stage'); var dg = false, lx = 0, ly = 0;
      var ptrs = {}, pcount = 0, pinchD0 = 0, pinchS0 = 1;
      function ptList() { var a = []; for (var k in ptrs) { if (ptrs.hasOwnProperty(k)) a.push(ptrs[k]); } return a; }
      function setZoomUI() { var z = el('va-fit-zoom'); if (z) z.value = Math.round(st.art.scale * 100); }
      stage.addEventListener('pointerdown', function (e) {
        if (!st.file) return;
        if (!ptrs[e.pointerId]) pcount++;
        ptrs[e.pointerId] = { x: e.clientX, y: e.clientY };
        if (pcount === 2) { var p = ptList(); pinchD0 = Math.hypot(p[0].x - p[1].x, p[0].y - p[1].y); pinchS0 = st.art.scale; dg = false; }
        else { dg = true; lx = e.clientX; ly = e.clientY; }
        try { stage.setPointerCapture(e.pointerId); } catch (_) {}
        e.preventDefault();
      });
      stage.addEventListener('pointermove', function (e) {
        if (ptrs[e.pointerId]) ptrs[e.pointerId] = { x: e.clientX, y: e.clientY };
        if (pcount >= 2 && pinchD0 > 0) {
          var p = ptList(); var d = Math.hypot(p[0].x - p[1].x, p[0].y - p[1].y);
          st.art.scale = Math.max(0.5, Math.min(3, pinchS0 * (d / pinchD0)));
          setZoomUI(); fitRender(); e.preventDefault(); return;
        }
        if (!dg) return;
        st.art.x += (e.clientX - lx); st.art.y += (e.clientY - ly); lx = e.clientX; ly = e.clientY; fitRender(); e.preventDefault();
      });
      function endd(e) {
        if (e && ptrs[e.pointerId]) { delete ptrs[e.pointerId]; pcount = Math.max(0, pcount - 1); }
        if (pcount < 2) pinchD0 = 0;
        if (pcount === 1) { var r = ptList()[0]; if (r) { dg = true; lx = r.x; ly = r.y; } }
        if (pcount === 0) dg = false;
      }
      stage.addEventListener('pointerup', endd); stage.addEventListener('pointercancel', endd);
      // trackpad / mouse-wheel zoom (desktop)
      stage.addEventListener('wheel', function (e) {
        if (!st.file || !st.fitActive) return;
        e.preventDefault();
        st.art.scale = Math.max(0.5, Math.min(3, st.art.scale * (e.deltaY < 0 ? 1.08 : 0.926)));
        setZoomUI(); fitRender();
      }, { passive: false });
    }
    function fitShow(s) { var h = el('va-fit'); if (h) h.style.display = s ? 'block' : 'none'; }
    function fitSetup(file, ty) {
      var raster = (ty === 'png' || ty === 'jpg' || ty === 'webp');
      st.fitActive = raster && !!(st.dims && st.dims.w);
      fitShow(st.fitActive);
      if (st.fitActive) { var _z = el('va-fit-zoom'); if (_z) _z.value = 100; var _h = el('va-fit'); if (_h) [].slice.call(_h.querySelectorAll('.va-fit-mode')).forEach(function (x) { x.classList.toggle('on', x.getAttribute('data-mode') === 'cover'); }); var art = el('va-fit-art'); if (art && st.objUrl) art.style.backgroundImage = 'url("' + st.objUrl + '")'; filmSync(); fitRender(); }
      updateButton();
    }
    function fitRender() {
      var stage = el('va-fit-stage'), art = el('va-fit-art'); if (!stage || !art || !st.dims) return;
      var fw = stage.clientWidth, fh = stage.clientHeight; if (!fw) { setTimeout(fitRender, 60); return; }
      var iw = st.dims.w, ih = st.dims.h;
      var base = (st.art.mode === 'contain' ? Math.min(fw / iw, fh / ih) : Math.max(fw / iw, fh / ih)) * st.art.scale;
      var dw = iw * base, dh = ih * base;
      var halfX = Math.abs(fw - dw) / 2, halfY = Math.abs(fh - dh) / 2;
      st.art.x = Math.max(-halfX, Math.min(halfX, st.art.x));
      st.art.y = Math.max(-halfY, Math.min(halfY, st.art.y));
      art.style.width = dw + 'px'; art.style.height = dh + 'px';
      art.style.left = ((fw - dw) / 2 + st.art.x) + 'px'; art.style.top = ((fh - dh) / 2 + st.art.y) + 'px';
      var mmPerImgPx = base * (LBL_W_MM / fw);
      var dpi = Math.round(25.4 / mmPerImgPx); st.art.dpi = dpi;
      var badge = el('va-fit-dpi'); if (badge) { badge.textContent = dpi + ' DPI'; badge.className = 'va-fit-dpi ' + (dpi < DPI_MIN ? 'bad' : (dpi < DPI_PASS ? 'warn' : 'ok')); }
      var msg = el('va-fit-msg');
      if (msg) {
        var arImg = iw / ih, arLabel = LONG / SHORT, ad = Math.abs(arImg - arLabel) / arLabel;
        if (ad > 0.06) { msg.className = 'va-fit-msg show'; msg.innerHTML = 'Your artwork is <b>' + arImg.toFixed(2) + ':1</b>, but our labels are <b>1.77 &times; 0.75&nbsp;in</b> (a wide ' + arLabel.toFixed(2) + ':1). Frame it below so nothing important gets cut off &mdash; or redesign your file at <b>1.77 &times; 0.75&nbsp;in</b> for a perfect edge-to-edge fit.'; }
        else { msg.className = 'va-fit-msg'; msg.innerHTML = ''; }
      }
      updateButton();
    }
    function fitApplyProps() {
      if (!st.fitActive) return;
      var stage = el('va-fit-stage'); var fw = (stage && stage.clientWidth) || 1;
      var mmPerPx = LBL_W_MM / fw;
      function sv(id, v) { var e = el(id); if (e) e.value = v; }
      sv('va-upl-artfit', st.art.mode);
      sv('va-upl-artscale', String(Math.round(st.art.scale * 1000) / 1000));
      sv('va-upl-artx', String(Math.round(st.art.x * mmPerPx * 100) / 100));
      sv('va-upl-arty', String(Math.round(st.art.y * mmPerPx * 100) / 100));
      if (st.art.dpi != null) sv('va-upl-dpi', String(st.art.dpi));
    }

    /* Build a small label-aspect thumbnail of the FRAMED artwork so the CART can
       SHOW the customer their design (instead of a generic holo swatch + "preview
       unavailable"). Mirrors the server crop transform (_art_fit/scale/x/y in mm).
       Rasters only — a PDF won't decode as an <img>, so cb(null) and the cart keeps
       its honest note. Fail-open everywhere (a bad thumb must never block ATC). */
    function _makeUploadThumb(cb) {
      try {
        if (!st.dims || !st.file) { cb(null); return; }
        var W_MM = 45.0, H_MM = 19.05, CW = 360, CH = Math.round(CW * H_MM / W_MM);
        var iw = st.dims.w, ih = st.dims.h;
        var mode = (el('va-upl-artfit') && el('va-upl-artfit').value) || (st.art && st.art.mode) || 'cover';
        var scale = parseFloat(el('va-upl-artscale') && el('va-upl-artscale').value) || (st.art && st.art.scale) || 1;
        var axmm = parseFloat(el('va-upl-artx') && el('va-upl-artx').value) || 0;
        var aymm = parseFloat(el('va-upl-arty') && el('va-upl-arty').value) || 0;
        var _u = URL.createObjectURL(st.file), img = new Image();
        img.onload = function () {
          var out = null;
          try {
            var c = document.createElement('canvas'); c.width = CW; c.height = CH;
            var ctx = c.getContext('2d');
            ctx.fillStyle = '#ffffff'; ctx.fillRect(0, 0, CW, CH);   // white = bare holo film
            var base = (mode === 'contain' ? Math.min(CW / iw, CH / ih) : Math.max(CW / iw, CH / ih)) * scale;
            var dw = iw * base, dh = ih * base;
            ctx.drawImage(img, (CW - dw) / 2 + axmm * (CW / W_MM), (CH - dh) / 2 + aymm * (CH / H_MM), dw, dh);
            out = c.toDataURL('image/jpeg', 0.72);
          } catch (e) {}
          try { URL.revokeObjectURL(_u); } catch (e) {}
          cb(out);
        };
        img.onerror = function () { try { URL.revokeObjectURL(_u); } catch (e) {} cb(null); };
        img.src = _u;
      } catch (e) { cb(null); }
    }

    /* ---------- cart add ---------- */
    function addToCart() {
      if (btn.disabled) return;
      var q = snapPack(st.qty), mat = st.material;
      var byQ = VARIANTS[String(q)] || {};
      var vid = byQ[mat] || byQ['Aurora'];
      if (!vid) { alert('Sorry, we could not match a product variant. Please refresh and try again.'); return; }
      el('va-upl-vid').value = vid;
      el('va-upl-pack').value = q + ' Labels';
      el('va-upl-mat').value = mat;
      el('va-upl-qty').value = String(q);
      el('va-upl-agree').value = 'Accepted - reviewed & approved proof; certified content rights; acknowledged printing-service (Terms v2)';
      el('va-upl-dpi').value = (st.vres && st.vres.dpi != null) ? String(st.vres.dpi) : '';
      var ackIds = (st.vres && st.vres.acks ? st.vres.acks.map(function (a) { return a.id; }) : []);
      el('va-upl-ack').value = (ackIds.length ? 'ack:' + ackIds.join(',') : 'clean') + ' @ ' + new Date().toISOString();
      fitApplyProps();
      if (window.vaTrack) { try { window.vaTrack('add_to_cart', { d: 'custom_upload', c: 'upload' }); } catch (e) {} }
      if (!fileInput.files || !fileInput.files.length) { alert('Please re-select your artwork with the Choose file button, then add to cart.'); try { fileInput.click(); } catch (e) {} return; }
      var _origBtn = btn.textContent;
      var _file = fileInput.files[0];
      // start rendering the cart thumbnail now (ready well before the upload+add returns)
      var _thumbP = new Promise(function (res) { try { _makeUploadThumb(res); } catch (e) { res(null); } });
      btn.disabled = true; btn.textContent = 'Uploading artwork...';
      /* Artwork goes to the CF Worker (R2), NOT Shopify. Shopify only ever sees
         the opaque _upload_id. On any failure we STOP (never fall back to a
         Shopify file upload — that would re-leak the artwork). */
      var _upBase = cfg.workerUpload || ((cfg.workerLabels || '').replace(/\/labels\/?$/, '') + '/upload');
      fetch(_upBase, { method: 'POST', headers: { 'Content-Type': _file.type || 'application/octet-stream' }, body: _file })
        .then(function (r) { if (!r.ok) throw new Error('upload ' + r.status); return r.json(); })
        .then(function (u) {
          if (!u || !u.id) throw new Error('upload returned no id');
          btn.textContent = 'Adding...';
          var props = {
            _template: 'custom_upload', _label_style: 'upload', _design: 'Uploaded Artwork',
            Pack: el('va-upl-pack').value, Material: el('va-upl-mat').value,
            Quantity: el('va-upl-qty').value, Agreement: el('va-upl-agree').value,
            _art_dpi: el('va-upl-dpi').value, _art_ack: el('va-upl-ack').value,
            _art_fit: el('va-upl-artfit').value, _art_scale: el('va-upl-artscale').value,
            _art_x: el('va-upl-artx').value, _art_y: el('va-upl-arty').value,
            _upload_id: u.id, _upload_type: u.type || (_file.type || '')
          };
          Object.keys(props).forEach(function (k) { if (props[k] === '' || props[k] == null) delete props[k]; });
          return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: el('va-upl-vid').value, quantity: 1, properties: props }) });
        })
        .then(function (r) { if (!r.ok) return r.json().then(function (j) { throw new Error((j && j.description) || ('cart ' + r.status)); }); return r.json(); })
        .then(function (res) {
          // stash the framed thumbnail against the new cart line so /cart shows the
          // customer THEIR artwork (keyed va_lp_<line key>, read by cart-products.liquid)
          var key = res && (res.key || (res.items && res.items[0] && res.items[0].key));
          return _thumbP.then(function (t) {
            try { if (key && t) localStorage.setItem('va_lp_' + key, JSON.stringify({ img: t, name: 'Uploaded Artwork' })); } catch (e) {}
            window.location.href = '/cart';
          });
        })
        .catch(function (e) { btn.disabled = false; btn.textContent = _origBtn; alert('Upload failed — please try again.\n(' + (e && e.message ? e.message : e) + ')'); });
    }

    /* ---------- wire up ---------- */
    choose.addEventListener('click', function (e) { e.stopPropagation(); fileInput.click(); });
    drop.addEventListener('click', function () { fileInput.click(); });
    fileInput.addEventListener('change', function () { if (fileInput.files && fileInput.files[0]) handleFile(fileInput.files[0]); });
    ['dragenter', 'dragover'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); e.stopPropagation(); drop.classList.add('drag'); }); });
    ['dragleave', 'drop'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); e.stopPropagation(); if (ev === 'dragleave') drop.classList.remove('drag'); }); });
    drop.addEventListener('drop', function (e) {
      drop.classList.remove('drag');
      var f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
      if (f) { setInputFile(f); handleFile(f); }
    });
    btn.addEventListener('click', addToCart);

    fitInit(); renderMaterials(); renderPacks(); updateButton();

    // material availability from the live design Worker (defensive: only disable on explicit out-of-stock)
    if (cfg.workerLabels) {
      fetch(cfg.workerLabels, { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (j) {
        var mats = (j && j.materials) || {};
        MATERIALS.forEach(function (m) {
          var rec = mats[m.name];
          if (rec == null && m.name) rec = mats[m.name.toLowerCase()] || mats[m.name.replace(/\s+/g, '_').toLowerCase()];
          var inStock = true;
          if (typeof rec === 'boolean') inStock = rec;
          else if (rec && typeof rec === 'object') {
            if ('in_stock' in rec) inStock = !!rec.in_stock;
            else if ('available' in rec) inStock = !!rec.available;
            else if ('stock' in rec) inStock = !!rec.stock;
          }
          st.stock[m.name] = inStock;
        });
        if (st.stock[st.material] === false) { var first = MATERIALS.filter(function (m) { return st.stock[m.name] !== false; })[0]; if (first) st.material = first.name; }
        renderMaterials(); filmSync(); updateButton();
      }).catch(function () {});
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
